import styled from 'styled-components';

const ErrorContainer = styled.div<{ hideBackground?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
`;

export default ErrorContainer;
